import { requestWrapper } from '@/util/util';



export default {
  methods: {
    requestWrapper,
  },
};
